import React, { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { ConfigurationDataContext } from 'context/configuration';
import { UiContext } from 'context/ui';

import { BlockHeading } from 'components/BlockHeading';
import GlassConfigTable from './partials/GlassConfigTable';
import GlassConfigDetailFirst from './partials/GlassConfigDetailFirst';
import GlassConfigDetailSecond from './partials/GlassConfigDetailSecond';

const GlassConfig = ({
	configurationData,
	glassTypeId,
	showPrice,
	freezerRef = null, // only for interaction/buttons (CartPage, not PreviewPage)
	activeInputRowCellRef = null, // ^^
	isPreview = false, // no interactions/buttons (only for PreviewPage)
}) => {
	const glassIndex = configurationData.glassTypes.findIndex(o => o.id === glassTypeId);
	const glassData = configurationData.glassTypes[glassIndex];
	const { priceVolumeCat } = configurationData.totals.totalGlassSizesSum;
	const { editConfiguration } = useContext(ConfigurationDataContext);
	const { showPopupByKey } = useContext(UiContext);
	const { t } = useTranslation();

	const editGlassItem = e => {
		e.preventDefault();
		e.stopPropagation();
		showPopupByKey('genericWarning', {
			title: t('notifications:confirmationOfGlassEdit'),
			confirmDialog: isConfirmed => isConfirmed && editConfiguration(glassData),
		});
	};

	const handleKeyDown = e => {
		if (e.key === 'Enter' || e.key === ' ') {
			editGlassItem(e);
		}
	};

	return (
		<div className="glass_config">
			<BlockHeading // with showGlassConfigButtons (this comment for easier grepping)
				configurationData={configurationData}
				freezerRef={freezerRef}
				glassTypeId={glassTypeId}
				title={glassData.fireResistant.concat(
					glassData.flatGlassStructure.structure === '1-glazed' ? '' : ' ISO'
				)}
				displayedBlockPosition={glassIndex + 1}
				showGlassConfigButtons={!isPreview}
				showPrice={showPrice}
			/>
			<div className={`glass_config_details_wrapper ${!isPreview ? 'glass_config_details_wrapper--editable' : ''}`}>
				{!isPreview && (
					<div
						className="glass_config_details_overlay"
						onClick={editGlassItem}
						onKeyDown={handleKeyDown}
						role="button"
						tabIndex={0}
						aria-label={t('commonConfigurationAction:editThisGlass')}
					/>
				)}
				<GlassConfigDetailFirst configDetails={glassData} />
				<GlassConfigDetailSecond
					configDetails={glassData}
					showPrice={showPrice}
					priceVolumeCat={priceVolumeCat}
				/>
			</div>
			<GlassConfigTable
				configurationData={configurationData}
				isPreview={isPreview}
				freezerRef={freezerRef}
				activeInputRowCellRef={activeInputRowCellRef}
				glassTypeId={glassTypeId}
				showPrice={showPrice}
			/>
		</div>
	);
};

export default GlassConfig;
